import type { ReactNode } from 'react';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { Broadcast } from './Broadcast';

type MainProps = {
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
    podlets?: Record<string, any>;
    broadcastUrl?: string;
    className?: string;
    customContainer?: boolean;
    children: ReactNode;
};

export const Main = ({ broadcastUrl, className, customContainer = false, children }: MainProps) => (
    <main className={`${customContainer ? '' : 'page-container '}${className ?? ''}`}>
        {broadcastUrl && <Broadcast url={broadcastUrl} />}
        {children}
    </main>
);

export const MainStatic = ({ className, children }: Omit<MainProps, 'broadcastUrl' | 'customContainer'>) => (
    <>
        <Header />
        <main className={className ?? 'page-container'} data-testid="mainContainer">
            {children}
        </main>
        <Footer />
    </>
);

// Two 'page-container' areas with different background colors, common for admin pages.
export const MainSplit = ({ top, podlets, broadcastUrl, className, children }: MainProps & { top: ReactNode }) => {
    const renderMain = () => (
        <>
            <section className={`page-container ${className ?? ''}`}>
                {broadcastUrl && <Broadcast url={broadcastUrl} />}
                {top}
            </section>
            <main className="s-bg-hover border-t s-border">
                <div className={`page-container s-bg-hover ${className ?? ''}`}>{children}</div>
            </main>
        </>
    );

    return podlets ? (
        <>
            {podlets.header ? <div {...podlets.header.props} /> : <Header />}
            <div {...podlets.advertising?.props} />
            {renderMain()}
            {podlets.footer ? <div {...podlets.footer.props} /> : <Footer />}
            {podlets.js?.map((script) => (
                <script {...script.props} key={script.key} crossOrigin="" defer />
            ))}
        </>
    ) : (
        renderMain()
    );
};
